(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neon-design-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('neon-design-guide')){
  customElements.define('neon-design-guide',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.observer?.disconnect();this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.tabs=[...this.querySelectorAll('[data-guide-tab]')];this.panels=[...this.querySelectorAll('[data-guide-panel]')];
      if(this.tabs.length!==6||this.panels.length!==6)return;
      this.querySelector('[data-guide-nav]').hidden=false;
      this.tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>this.select(index),options);
        tab.addEventListener('keydown',event=>{
          let target;
          if(event.key==='ArrowRight')target=(index+1)%6;
          else if(event.key==='ArrowLeft')target=(index+5)%6;
          else if(event.key==='Home')target=0;
          else if(event.key==='End')target=5;
          else return;
          event.preventDefault();this.select(target,true);
        },options);
      });
      this.querySelectorAll('[data-guide-studio]').forEach(link=>link.addEventListener('click',event=>{
        const studio=document.getElementById('studio'),control=document.getElementById(link.dataset.guideStudio);
        if(!studio||!control)return;
        event.preventDefault();control.click();
        studio.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
        control.focus({preventScroll:true});
      },options));
      this.select(Number.isInteger(this.active)?this.active:0);
      if('IntersectionObserver' in window){
        this.observer=new IntersectionObserver(entries=>{
          if(!entries.some(entry=>entry.isIntersecting))return;
          this.querySelectorAll('.ndg-visual img').forEach(img=>{img.loading='eager'});this.observer.disconnect();
        },{rootMargin:'300px'});this.observer.observe(this);
      }
    }
    select(index,focus=false){
      this.active=index;this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index});
      if(focus)this.tabs[index].focus({preventScroll:true});
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neon-showroom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('neon-showroom')) {
  class NeonShowroom extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.canvas = this.querySelector('canvas');
      this.viewport = this.querySelector('[data-viewer]');
      this.context = this.canvas.getContext('2d', { alpha: false });
      this.looks = [...this.querySelectorAll('[data-look]')];
      this.hotspots = [...this.querySelectorAll('[data-hotspot]')];
      this.signs = [...this.querySelectorAll('[data-neon]')];
      this.roomImages = [...this.querySelectorAll('[data-room-texture]')];
      this.effects = this.looks.map(look => look.dataset.defaultEffect);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.active = 0;
      this.pitch = -0.08;
      this.yaw = this.lookYaw(0);
      this.visible = true;
      this.effectsPaused = false;
      this.tour = false;
      this.ready = false;
      this.frame = 0;
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this.viewport);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].intersectionRatio >= 0.12;
        if (!this.visible) this.stopTour();
        this.syncEffects();
      }, { threshold: 0.12 });
      this.intersectionObserver.observe(this.viewport);
      this.bind();
      this.resize();
      this.load();
    }

    disconnectedCallback() {
      this.abort.abort();
      this.resizeObserver.disconnect();
      this.intersectionObserver.disconnect();
      cancelAnimationFrame(this.frame);
      this.initialized = false;
    }

    listen(target, event, callback, options = {}) {
      target.addEventListener(event, callback, { ...options, signal: this.abort.signal });
    }

    clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

    lookYaw(index) { return (Number(this.looks[index].dataset.u) - 0.5) * Math.PI * 2; }

    baseFov() { return (this.width < 650 ? 74 : 100) * Math.PI / 180; }

    resize() {
      const bounds = this.viewport.getBoundingClientRect();
      const previousWidth = this.width;
      this.width = Math.max(1, bounds.width);
      this.height = Math.max(1, bounds.height);
      if (!this.fov || (previousWidth < 650) !== (this.width < 650)) this.fov = this.baseFov();
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.round(Math.min(this.width * ratio, this.width < 650 ? 850 : 1600));
      const height = Math.max(1, Math.round(width * this.height / this.width));
      if (this.canvas.width !== width || this.canvas.height !== height) {
        this.canvas.width = width;
        this.canvas.height = height;
      }
      this.requestRender();
    }

    async load() {
      try {
        if (!this.context) throw new Error('Canvas unavailable');
        await Promise.all(this.roomImages.map(image => {
          if (image.complete) return image.naturalWidth ? Promise.resolve() : Promise.reject(new Error('Image unavailable'));
          return new Promise((resolve, reject) => {
            this.listen(image, 'load', resolve, { once: true });
            this.listen(image, 'error', reject, { once: true });
          });
        }));
        if (!this.isConnected) return;
        this.textures = [...this.roomImages, this.material(true), this.material(false)];
        this.mesh = this.buildMesh();
        this.ready = true;
        this.canvas.hidden = false;
        this.querySelector('[data-signs]').hidden = false;
        this.render();
        this.querySelector('[data-poster]').hidden = true;
        ['data-loading', 'data-controls', 'data-hotspots', 'data-effects'].forEach(attribute => {
          this.querySelector('[' + attribute + ']').hidden = attribute === 'data-loading';
        });
        const help = this.querySelector('[data-help]');
        help.textContent = help.dataset.interactive;
        this.querySelector('[data-action="tour"]').hidden = this.motion.matches;
        this.syncEffects();
        this.updateLinks();
        this.setAttribute('data-ready', 'true');
      } catch {
        this.ready = false;
        this.querySelector('[data-loading]').hidden = true;
        this.querySelector('[data-poster]').hidden = false;
        this.canvas.hidden = true;
        ['data-signs', 'data-controls', 'data-hotspots', 'data-effects'].forEach(attribute => {
          this.querySelector('[' + attribute + ']').hidden = true;
        });
        this.setAttribute('data-ready', 'fallback');
      }
    }

    material(ceiling) {
      const image = document.createElement('canvas');
      image.width = image.height = 256;
      const context = image.getContext('2d');
      const gradient = context.createRadialGradient(128, 128, 12, 128, 128, 190);
      gradient.addColorStop(0, ceiling ? '#26211d' : '#9d7856');
      gradient.addColorStop(1, ceiling ? '#161514' : '#6e513c');
      context.fillStyle = gradient;
      context.fillRect(0, 0, 256, 256);
      context.strokeStyle = ceiling ? '#b58b4438' : '#dec39b45';
      context.lineWidth = 1;
      for (let offset = 0; offset <= 256; offset += 64) {
        context.beginPath();
        context.moveTo(offset, 0);
        context.lineTo(offset, 256);
        context.moveTo(0, offset);
        context.lineTo(256, offset);
        context.stroke();
      }
      return image;
    }

    wallPoint(face, x, y) {
      if (face === 0) return [x, y, 1];
      if (face === 1) return [1, y, -x];
      if (face === 2) return [-x, y, -1];
      return [-1, y, x];
    }

    cubePoint(face, u, v) {
      const a = 2 * u - 1;
      const b = 1 - 2 * v;
      if (face < 4) return this.wallPoint(face, a, b);
      return face === 4 ? [a, 1, -b] : [a, -1, b];
    }

    buildMesh() {
      return this.textures.map((image, face) => {
        const segments = face < 4 ? 10 : 6;
        const vertices = [];
        const triangles = [];
        for (let y = 0; y <= segments; y++) {
          for (let x = 0; x <= segments; x++) {
            const u = x / segments;
            const v = y / segments;
            vertices.push({ point: this.cubePoint(face, u, v), u, v });
          }
        }
        for (let y = 0; y < segments; y++) {
          for (let x = 0; x < segments; x++) {
            const a = y * (segments + 1) + x;
            const b = a + 1;
            const c = a + segments + 1;
            const d = c + 1;
            triangles.push([a, b, d], [a, d, c]);
          }
        }
        return { image, vertices, triangles };
      });
    }

    camera(point) {
      const x = this.cosYaw * point[0] - this.sinYaw * point[2];
      const z = this.sinYaw * point[0] + this.cosYaw * point[2];
      return { x, y: this.cosPitch * point[1] - this.sinPitch * z, z: this.sinPitch * point[1] + this.cosPitch * z };
    }

    project(vertex) {
      return { x: this.width / 2 + vertex.x / vertex.z * this.focal, y: this.height / 2 - vertex.y / vertex.z * this.focal, u: vertex.u, v: vertex.v };
    }

    clipNear(vertices) {
      const result = [];
      const near = 0.08;
      vertices.forEach((current, index) => {
        const previous = vertices[(index + vertices.length - 1) % vertices.length];
        const inside = current.z >= near;
        const previousInside = previous.z >= near;
        if (inside !== previousInside) {
          const t = (near - previous.z) / (current.z - previous.z);
          result.push({
            x: previous.x + (current.x - previous.x) * t,
            y: previous.y + (current.y - previous.y) * t,
            z: near,
            u: previous.u + (current.u - previous.u) * t,
            v: previous.v + (current.v - previous.v) * t
          });
        }
        if (inside) result.push(current);
      });
      return result;
    }

    drawTriangle(image, points) {
      if (points.every(point => point.x < -1) || points.every(point => point.x > this.width + 1) || points.every(point => point.y < -1) || points.every(point => point.y > this.height + 1)) return;
      const [p0, p1, p2] = points;
      const width = image.naturalWidth || image.width;
      const height = image.naturalHeight || image.height;
      const sx1 = (p1.u - p0.u) * width;
      const sx2 = (p2.u - p0.u) * width;
      const sy1 = (p1.v - p0.v) * height;
      const sy2 = (p2.v - p0.v) * height;
      const determinant = sx1 * sy2 - sx2 * sy1;
      if (Math.abs(determinant) < 0.0001) return;
      const dx1 = p1.x - p0.x;
      const dx2 = p2.x - p0.x;
      const dy1 = p1.y - p0.y;
      const dy2 = p2.y - p0.y;
      const a = (dx1 * sy2 - dx2 * sy1) / determinant;
      const b = (dy1 * sy2 - dy2 * sy1) / determinant;
      const c = (sx1 * dx2 - sx2 * dx1) / determinant;
      const d = (sx1 * dy2 - sx2 * dy1) / determinant;
      const e = p0.x - a * p0.u * width - c * p0.v * height;
      const f = p0.y - b * p0.u * width - d * p0.v * height;
      const centerX = (p0.x + p1.x + p2.x) / 3;
      const centerY = (p0.y + p1.y + p2.y) / 3;
      const context = this.context;
      context.save();
      context.beginPath();
      points.forEach((point, index) => {
        const dx = point.x - centerX;
        const dy = point.y - centerY;
        const length = Math.max(1, Math.hypot(dx, dy));
        const x = point.x + dx / length * 0.5;
        const y = point.y + dy / length * 0.5;
        if (index === 0) context.moveTo(x, y);
        else context.lineTo(x, y);
      });
      context.closePath();
      context.clip();
      context.transform(a, b, c, d, e, f);
      context.drawImage(image, 0, 0);
      context.restore();
    }

    bind() {
      this.listen(this, 'click', event => {
        const look = event.target.closest('[data-look], [data-hotspot]');
        if (look && this.contains(look) && this.ready && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          this.select(Number(look.dataset.look ?? look.dataset.hotspot));
          if (look.hasAttribute('data-hotspot')) {
            this.previewTrigger = look;
            this.querySelector('[data-preview-card]').hidden = false;
            this.querySelector('[data-preview-card]').focus({ preventScroll: true });
          }
          return;
        }
        const effect = event.target.closest('[data-effect-choice]');
        if (effect && this.contains(effect) && this.ready) {
          this.effects[this.active] = effect.dataset.effectChoice;
          this.signs[this.active].dataset.effect = effect.dataset.effectChoice;
          this.syncEffects();
          this.updateLinks();
          return;
        }
        const action = event.target.closest('[data-action]');
        if (!action || !this.contains(action) || !this.ready) return;
        if (action.dataset.action === 'close-preview') { this.closePreview(); return; }
        if (action.dataset.action === 'effects') {
          this.effectsPaused = !this.effectsPaused;
          this.syncEffects();
          return;
        }
        if (action.dataset.action === 'tour') {
          if (this.tour) this.stopTour();
          else this.startTour();
          return;
        }
        this.stopTour();
        this.transition = null;
        if (action.dataset.action === 'reset') this.select(this.active);
        else {
          this.fov = this.clamp(this.fov + (action.dataset.action === 'zoom-in' ? -0.12 : 0.12), 1.04, 1.92);
          this.requestRender();
        }
      });
      this.listen(this.canvas, 'keydown', event => {
        if (!this.ready) return;
        const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', '+', '=', '-', 'Home'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        this.stopTour();
        this.transition = null;
        if (event.key === 'Home') { this.select(this.active); return; }
        if (event.key === 'ArrowLeft') this.yaw -= 0.10;
        if (event.key === 'ArrowRight') this.yaw += 0.10;
        if (event.key === 'ArrowUp') this.pitch = this.clamp(this.pitch + 0.06, -0.32, 0.35);
        if (event.key === 'ArrowDown') this.pitch = this.clamp(this.pitch - 0.06, -0.32, 0.35);
        if (event.key === '+' || event.key === '=') this.fov = this.clamp(this.fov - 0.12, 1.04, 1.92);
        if (event.key === '-') this.fov = this.clamp(this.fov + 0.12, 1.04, 1.92);
        this.requestRender();
      });
      this.listen(this.canvas, 'pointerdown', event => {
        if (!this.ready || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.stopTour();
        this.transition = null;
        this.pointer = { id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, yaw: this.yaw, pitch: this.pitch, dragging: false };
        if (event.pointerType === 'mouse') this.canvas.setPointerCapture(event.pointerId);
      });
      this.listen(this.canvas, 'pointermove', event => {
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;
        if (!pointer.dragging && Math.hypot(dx, dy) < 7) return;
        if (!pointer.dragging && pointer.type !== 'mouse' && Math.abs(dy) > Math.abs(dx)) return;
        if (!pointer.dragging) {
          pointer.dragging = true;
          this.canvas.setPointerCapture(event.pointerId);
          this.canvas.classList.add('is-dragging');
        }
        this.yaw = pointer.yaw - dx / this.width * this.fov;
        if (pointer.type === 'mouse') this.pitch = this.clamp(pointer.pitch + dy / this.width * this.fov, -0.32, 0.35);
        this.requestRender();
      });
      const endPointer = event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        this.pointer = null;
        this.canvas.classList.remove('is-dragging');
        if (this.canvas.hasPointerCapture(event.pointerId)) this.canvas.releasePointerCapture(event.pointerId);
        this.requestRender();
      };
      this.listen(this.canvas, 'pointerup', endPointer);
      this.listen(this.canvas, 'pointercancel', endPointer);
      this.listen(this.canvas, 'lostpointercapture', endPointer);
      this.listen(document, 'visibilitychange', () => {
        if (document.hidden) this.stopTour();
        this.syncEffects();
      });
      this.listen(this.querySelector('[data-preview-card]'), 'keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.closePreview(); }
      });
      this.listen(this.motion, 'change', () => {
        this.stopTour();
        this.transition = null;
        this.querySelector('[data-action="tour"]').hidden = this.motion.matches;
        this.syncEffects();
        this.requestRender();
      });
    }

    syncEffects() {
      this.dataset.motion = !this.effectsPaused && this.visible && !this.motion.matches && !document.hidden ? 'running' : 'paused';
      this.querySelectorAll('[data-effect-choice]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.effectChoice === this.effects[this.active]));
      });
      const button = this.querySelector('[data-action="effects"]');
      button.setAttribute('aria-pressed', String(this.effectsPaused));
      button.disabled = this.motion.matches;
      button.textContent = this.motion.matches ? button.dataset.reduced : this.effectsPaused ? button.dataset.resume : button.dataset.pause;
    }

    updateLinks() {
      this.looks.forEach((look, index) => {
        const url = new URL(look.href);
        if (this.effects[index] === 'static') url.searchParams.delete('rgb');
        else url.searchParams.set('rgb', 'true');
        look.href = url.href;
      });
      this.querySelector('[data-current-link]').href = this.looks[this.active].href;
      this.querySelector('[data-preview-link]').href = this.looks[this.active].href;
    }

    closePreview() {
      this.querySelector('[data-preview-card]').hidden = true;
      if (this.previewTrigger && !this.previewTrigger.hidden) this.previewTrigger.focus({ preventScroll: true });
    }

    select(index) {
      const look = this.looks[index];
      if (!look) return;
      this.stopTour();
      this.querySelector('[data-preview-card]').hidden = true;
      this.active = index;
      this.looks.forEach((item, position) => {
        item.classList.toggle('is-selected', position === index);
        if (position === index) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      this.querySelector('[data-current-name]').textContent = look.querySelector('strong').textContent;
      this.querySelector('[data-current-description]').textContent = look.dataset.description;
      this.querySelector('[data-preview-name]').textContent = look.querySelector('strong').textContent;
      this.syncEffects();
      this.updateLinks();
      const target = this.lookYaw(index);
      const delta = Math.atan2(Math.sin(target - this.yaw), Math.cos(target - this.yaw));
      if (this.motion.matches) {
        this.yaw += delta;
        this.pitch = -0.08;
        this.fov = this.baseFov();
        this.transition = null;
      } else {
        this.transition = { start: performance.now(), yaw: this.yaw, delta, pitch: this.pitch, fov: this.fov };
      }
      this.requestRender();
    }

    startTour() {
      if (this.motion.matches || !this.visible || document.hidden) return;
      this.transition = null;
      this.querySelector('[data-preview-card]').hidden = true;
      this.tour = true;
      this.lastTime = performance.now();
      const button = this.querySelector('[data-action="tour"]');
      button.setAttribute('aria-pressed', 'true');
      button.textContent = button.dataset.stop;
      this.requestRender();
    }

    stopTour() {
      this.tour = false;
      const button = this.querySelector('[data-action="tour"]');
      button.setAttribute('aria-pressed', 'false');
      button.textContent = button.dataset.start;
    }

    requestRender() {
      if (!this.ready || this.frame) return;
      this.frame = requestAnimationFrame(time => this.tick(time));
    }

    tick(time) {
      this.frame = 0;
      if (!this.isConnected || !this.ready) return;
      if (this.transition) {
        const transition = this.transition;
        const progress = this.clamp((time - transition.start) / 900, 0, 1);
        const eased = progress * progress * (3 - 2 * progress);
        this.yaw = transition.yaw + transition.delta * eased;
        this.pitch = transition.pitch + (-0.08 - transition.pitch) * eased;
        this.fov = transition.fov + (this.baseFov() - transition.fov) * eased;
        if (progress === 1) this.transition = null;
      }
      if (this.tour) {
        this.yaw += Math.min(time - this.lastTime, 80) * Math.PI * 2 / 85000;
        this.lastTime = time;
      }
      this.yaw = Math.atan2(Math.sin(this.yaw), Math.cos(this.yaw));
      this.render();
      if (this.transition || (this.tour && this.visible && !document.hidden)) this.requestRender();
    }

    render() {
      if (!this.ready) return;
      this.sinYaw = Math.sin(this.yaw);
      this.cosYaw = Math.cos(this.yaw);
      this.sinPitch = Math.sin(this.pitch);
      this.cosPitch = Math.cos(this.pitch);
      this.focal = this.width / (2 * Math.tan(this.fov / 2));
      const context = this.context;
      context.setTransform(this.canvas.width / this.width, 0, 0, this.canvas.height / this.height, 0, 0);
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      context.fillStyle = '#171513';
      context.fillRect(0, 0, this.width, this.height);
      this.mesh.forEach(face => {
        const vertices = face.vertices.map(vertex => ({ ...this.camera(vertex.point), u: vertex.u, v: vertex.v }));
        face.triangles.forEach(triangle => {
          const clipped = this.clipNear(triangle.map(index => vertices[index]));
          if (clipped.length < 3) return;
          const projected = clipped.map(vertex => this.project(vertex));
          for (let index = 1; index < projected.length - 1; index++) {
            this.drawTriangle(face.image, [projected[0], projected[index], projected[index + 1]]);
          }
        });
      });
      this.positionSigns();
      this.positionHotspots();
      this.querySelector('[data-action="zoom-in"]').disabled = this.fov <= 1.0401;
      this.querySelector('[data-action="zoom-out"]').disabled = this.fov >= 1.9199;
    }

    homography(points, width, height) {
      const [p0, p1, p2, p3] = points;
      const dx1 = p1.x - p2.x;
      const dx2 = p3.x - p2.x;
      const dx3 = p0.x - p1.x + p2.x - p3.x;
      const dy1 = p1.y - p2.y;
      const dy2 = p3.y - p2.y;
      const dy3 = p0.y - p1.y + p2.y - p3.y;
      const determinant = dx1 * dy2 - dx2 * dy1;
      if (Math.abs(determinant) < 0.0001) return null;
      const g = (dx3 * dy2 - dx2 * dy3) / determinant;
      const h = (dx1 * dy3 - dx3 * dy1) / determinant;
      const a = p1.x - p0.x + g * p1.x;
      const b = p3.x - p0.x + h * p3.x;
      const d = p1.y - p0.y + g * p1.y;
      const e = p3.y - p0.y + h * p3.y;
      return [a / width, d / width, 0, g / width, b / height, e / height, 0, h / height, 0, 0, 1, 0, p0.x, p0.y, 0, 1];
    }

    positionSigns() {
      this.signs.forEach((sign, index) => {
        const corners = [[-0.67, 0.48], [0.67, 0.48], [0.67, 0.15], [-0.67, 0.15]].map(point => this.camera(this.wallPoint(index, point[0], point[1])));
        if (corners.some(point => point.z < 0.15)) { sign.hidden = true; return; }
        const projected = corners.map(point => this.project(point));
        const outside = projected.every(point => point.x < -100) || projected.every(point => point.x > this.width + 100) || projected.every(point => point.y < -100) || projected.every(point => point.y > this.height + 100);
        const matrix = outside ? null : this.homography(projected, 900, 180);
        sign.hidden = !matrix;
        if (matrix) sign.style.transform = 'matrix3d(' + matrix.join(',') + ')';
      });
    }

    positionHotspots() {
      this.hotspots.forEach((hotspot, index) => {
        const camera = this.camera(this.wallPoint(index, 0, -0.04));
        const position = this.project(camera);
        hotspot.hidden = camera.z <= 0 || position.x < this.width * 0.05 || position.x > this.width * 0.95 || position.y < this.height * 0.1 || position.y > this.height * 0.8;
        if (!hotspot.hidden) {
          hotspot.style.left = position.x + 'px';
          hotspot.style.top = position.y + 'px';
        }
      });
    }
  }
  customElements.define('neon-showroom', NeonShowroom);
}
  } catch(e) { console.error(e); }
})();

})();
